<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      @checkbox-change="(e) => $emit('checkbox-change', e)"
    >
      <pagination
        size="mini"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
        :layouts="['Total', 'Sizes', 'PrevPage', 'Number', 'NextPage']"
      />
    </page-main>
  </div>
</template>
<script>
const initPage = { curPage: 1, pageSize: 10, pageTotal: 0 }
import PageMain from './main.vue'
export default {
  components: { PageMain },
  props: {
    amazonStoreRegion: { type: String, default: '' },
    checkedKeys: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      usePage: true,
      loading: false,
      tableData: [],
      page: { ...initPage },
    }
  },
  watch: {
    amazonStoreRegion: {
      async handler() {
        await this.reset()
        this.getData()
      },
    },
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    async getData() {
      if (!this.amazonStoreRegion) return
      this.loading = true
      const params = {
        amazonStoreRegion: this.amazonStoreRegion,
        listAmzStoreStatus: ['Y'],
        listIsOwnInv: ['Y'],
        ...this.page,
      }
      await this.$api
        .ecomAmzStoreListApi(params)
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
          if (this.usePage) {
            this.page.pageTotal = res.body.count
            this.page.pageSize = res.body.pageSize
            this.page.curPage = res.body.curPage
          }

          this.$nextTick(() => {
            this.$refs.main.setCheckboxRows(this.checkedKeys)
          })
        })
        .catch(() => {
          this.loading = false
        })
    },
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.getData()
    },
    async reset() {
      this.tableData = []
      this.page = { ...initPage }
      if (this.$refs.main) this.$refs.main.clearCheckboxRow()
    },
  },
}
</script>
